import AuthBlock from "components/UI/authBlock/AuthBlock";
import env from '../../../package.json'
import OAuthService from 'services/OAuthService';

function OAuth({ setTokenInfo, setUserInfo }) {
    const yandexOAuth = () => {
        const urlResponseOauth = `https://oauth.yandex.ru/authorize?response_type=code&client_id=${env.yandexAPI.clientID}&redirect_uri=${env.redirectUri}&force_confirm=1`
        window.open(urlResponseOauth, '_self')
    }

    const keycloakOAuth = () => {
        // Получаем URL для авторизации через Keycloak
        const urlResponseOauth = OAuthService.getKeycloakLoginUrl();
        window.open(urlResponseOauth, '_self');
    };

    const handleAdminClick = () => {
        // Для администраторов тоже используем Keycloak (или можно настроить отдельный URL)
        const urlResponseOauth = OAuthService.getKeycloakLoginUrl();
        window.open(urlResponseOauth, '_self');
    };

    return (
        <AuthBlock 
            setTokenInfo={setTokenInfo} 
            setUserInfo={setUserInfo}
            yandexOAuth={yandexOAuth}
            keycloakOAuth={keycloakOAuth}
            onAdminClick={handleAdminClick}
        />
    );
}

export default OAuth;